import React, { useCallback, useMemo, useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import PdfJsViewer from './PdfJsViewer.web';
import { useTheme } from '@/context/ThemeContext';
import { downloadMedia } from '@/constants/utils/mediaDownload';

export default function PdfViewer({ file }) {
  const { colors } = useTheme();
  const source = file?.cdnPath || file?.url || file?.uri || null;
  const title = file?.name || 'PDF document';
  const [failed, setFailed] = useState(!source);
  const handleError = useCallback(() => setFailed(true), []);
  const styles = useMemo(() => StyleSheet.create({
    container: { flex: 1, backgroundColor: colors.solid_color_primary },
    error: { flex: 1, alignItems: 'center', justifyContent: 'center', gap: 12, padding: 24 },
    actions: { flexDirection: 'row', gap: 8 },
    button: { minHeight: 38, paddingHorizontal: 14, borderRadius: 8, flexDirection: 'row', alignItems: 'center', gap: 7, backgroundColor: colors.solid_color_secondary, cursor: 'pointer' },
  }), [colors]);

  if (failed) return (
    <View style={styles.error}>
      <Icon name="triangle-exclamation" size={26} color={colors.text_color_secondary} />
      <Text align="center">This PDF could not be rendered in the preview.</Text>
      <View style={styles.actions}>
        <Pressable accessibilityRole="button" onPress={() => source && window.open(source, '_blank', 'noopener,noreferrer')} style={styles.button}>
          <Icon name="arrow-up-right-from-square" size={14} color={colors.text_color_primary} />
          <Text>Open in new tab</Text>
        </Pressable>
        <Pressable accessibilityRole="button" onPress={() => source && downloadMedia(source, title)} style={styles.button}>
          <Icon name="arrow-down-to-line" size={14} color={colors.text_color_primary} />
          <Text>Download</Text>
        </Pressable>
      </View>
    </View>
  );
  return <View style={styles.container}><PdfJsViewer source={source} title={title} onError={handleError} /></View>;
}
